import { defineStore } from 'pinia';
import { usePage } from "@inertiajs/vue3";
import { useStorage } from '@vueuse/core';

const page = usePage();

export const useDefaultDataStore = defineStore('dafaultData', {
    state: () => ({
        estados: useStorage('estados', []),
        empresas: useStorage('empresas', []),
        alicuotas: useStorage('alicuotas', []),
        presupuestoGrid: useStorage('presupuestoGrid', {
            vista: 'presupuestos',
            filters: {
                estado: null,
                cliente: null,
                tipoProducto: null,
            },
            columnas: null,
        }),
        planificacionGantt: useStorage('planificacionGantt', {
            selectedMachine: null,
            start: null,
            end: null,
        }),
        estadosFlow: useStorage('estadosFlow', []),
    }),

    getters: {
        getEstados: (state) => state.estados,
        getAlicuotas: (state) => {
            return state.alicuotas.map((alicuota) => {
                return {
                    value: Number(alicuota.id),
                    label: alicuota.nombre,
                };
            });
        },
        getSelectEstados: (state) => {
            return state.estados.map((estado) => {
                return page.props?.auth?.can.includes('estado.select.show.' + estado.id) ? {
                    value: estado.id,
                    label: estado.nombre,
                    color: estado.color,
                } : null;
            }).filter(Boolean);
        },
        getSelectEstadosFlow(state) {
            return (nombre) => {
                const id = this.getEstadoIdByNombre(nombre);
                console.log('getSelectEstadosFlow', nombre, state.estadosFlow, state.estados);
                const allowedIds = state.estadosFlow?.[id] || [];
                return state.estados
                    .filter((estado) => allowedIds.includes(String(estado.id)))
                    .map((estado) => {
                        return page.props?.auth?.can.includes('estado.select.show.' + estado.id) ? {
                            value: estado.id,
                            label: estado.nombre,
                            color: estado.color,
                        } : null;
                    })
                    .filter(Boolean);
            };
        },
        getEstadoColor: (state, nombre) => {
            return (nombre) =>
                state.estados.find((estado) => estado.nombre === nombre)?.color || '';
        },
        getEstadoById: (state) => {
            return (id) => state.estados.find((estado) => estado.id === id);
        },
        getEstadoIdByNombre: (state) => {
            return (nombre) => state.estados.find((estado) => estado.nombre === nombre)?.id || null;
        },
        getEmpresas: (state) => state.empresas,
        getPresupuestoGridVista: (state) => state.presupuestoGrid.vista,
        getPresupuestoGridFilters: (state) => state.presupuestoGrid.filters,
        getPresupuestoGridColumnas: (state) => state.presupuestoGrid.columnas,
        getPlanificacionGanttMachine: (state) => state.planificacionGantt.selectedMachine,
        getPlanificacionGanttStart: (state) => state.planificacionGantt.start,
        getPlanificacionGanttEnd: (state) => state.planificacionGantt.end,
        getEstadosFlow: (state) => state.estadosFlow,
    },
    actions: {
        setAlicuotas(data) {
            this.alicuotas = data;
        },
        setEstados(data) {
            this.estados = data;
        },
        setEmpresas(data) {
            this.empresas = data;
        },
        setPresupuestoGrid(datos) {
            this.presupuestoGrid = { ...this.presupuestoGrid, ...datos };
        },
        setPlanificacionGantt(datos) {
            this.planificacionGantt = { ...this.planificacionGantt, ...datos };
        },
        setEstadosFlow(data) {
            this.estadosFlow = data;
        },
    },
});
